import { executionsConst } from 'features/executions'
import { type Dispatch, type SetStateAction, useId, useState } from 'react'
import { URLSearchParser } from 'shared/search-adapters'
import { ListSelect } from 'shared/ui'

import { isAddContactsModalOpen } from '../AddModal/util'
import css from './Filters.module.css'

const info = executionsConst.qualificationInfo

const OPTIONS = executionsConst.QUALIFICATIONS.map(value => ({
	...info[value],
	value
}))

type StateOption = (typeof OPTIONS)[number]

function getInitial(param: URLSearchParams) {
	const globals = URLSearchParser.QualificationValues(
		param,
		isAddContactsModalOpen()
	)

	const set = new Set(globals)

	return OPTIONS.filter(option => set.has(option.value))
}

QualificationsSelector.useState = (param: URLSearchParams) =>
	useState(getInitial(param))

export function QualificationsSelector({
	currents,

	setter
}: {
	currents: StateOption[]
	setter: Dispatch<SetStateAction<StateOption[]>>
}) {
	const id = useId()

	return (
		<div className={css.set}>
			<label className={css.label} htmlFor={id}>
				Qualification
			</label>
			<ListSelect
				formatOptionLabel={option => (
					<div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
						<img alt={option.label} src={option.emoji} />
						<span>{option.label}</span>
					</div>
				)}
				getOptionValue={option => option.value}
				getTag={option => option.label}
				inputId={id}
				isMulti
				onChange={values => setter(Array.from(values))}
				options={OPTIONS}
				placeholder='Select status'
				setter={setter}
				value={currents}
			/>
		</div>
	)
}
